export default __webpack_public_path__ + "static/media/mark-green-sm.43f8abd1.png";